import './scss/error.scss'

import {Component} from 'substance'
import {message, header} from '../../../lib/error/ErrorMessages'

/**
 * Renders a WriterError caught during startup
 *
 * @param {Component.Props} props
 * @property {Component.Props} props
 */
class ErrorComponent extends Component {

    didMount() {
        const {error} = this.props

        // TODO: send error to server log

        console.log(error.toString())
        console.log(error.parentError ? error.parentError : error)
    }

    render($$) {
        return $$('div')
            .addClass('dwc-error')
            .append([
                $$('h1').append(this._header()),
                $$('p').append(this._message()),
                $$('pre').append(this._errorId())
            ])
    }

    _header() {
        return header(
            this.props.error.code,
            this.props.labelLanguage || 'en'
        )
    }

    _message() {
        return message(
            this.props.error.code,
            this.props.labelLanguage || 'en'
        )
    }

    _errorId() {
        if (this.props.error.errorId) {
            return `Error id: ${this.props.error.errorId}`
        }

        return ''
    }
}

export {ErrorComponent}
